import React from 'react';
import { observer } from 'mobx-react';
import { WithNamespaces, withNamespaces } from 'react-i18next';

import { Repository } from 'apps/repository';
import { BreadCrumbs } from 'apps/repository/views/breadCrumbs';
import { Readme } from 'apps/readme/index';

import { clientStore } from 'apps/client/app';
import { routerStore } from 'core/routing';
import { conf } from 'apps/project/config.yaml';
import DocumentHead from 'legacyComponents/documentHead';

type FilesAndDirectoryPageProps = {
  params: any;
  projectManager: any;
  repoManager: any;
} & WithNamespaces;

export const FilesAndDirectoryPage = withNamespaces()(
  observer((props: FilesAndDirectoryPageProps) => {
    const { params, projectManager, repoManager, t } = props;
    const { project } = projectManager;

    let returnRoute = clientStore.spaceRoute.route;
    const routeParams = routerStore.params.toJSON();
    const basepath = routerStore.params.get('basepath');
    const basepathSegs = basepath ? basepath.split('/') : [];
    const projectRouteParams = routerStore.params.toJSON();
    const returnParams = projectRouteParams;
    delete projectRouteParams.basepath;

    if (basepathSegs.length > 1) {
      returnRoute = `${clientStore.spaceRoute.route}.files.directory`;
      const returnBasepath = basepathSegs
        .slice(0, basepathSegs.length - 1)
        .join('/');
      if (returnBasepath) {
        returnParams.basepath = returnBasepath;
      } else {
        delete returnParams.basepath;
      }
    }

    const insideFolder = routerStore.route.name.endsWith('directory');
    const shouldRenderReadme = insideFolder && repoManager.repository;
    const showHistory = !insideFolder;

    if (!project) return null;

    const breadCrumbs = (
      <BreadCrumbs
        basepathSegs={basepathSegs}
        routeParams={routeParams}
        projectRouteParams={projectRouteParams}
        repoManager={repoManager}
        content={project.content}
      />
    );

    return (
      <>
        <DocumentHead title={`${project.name} | Files`} />
        <Repository
          title={t(conf.sections[1])}
          crumbs={breadCrumbs}
          projectManager={projectManager}
          repoManager={repoManager}
          showHistory={showHistory}
          returnLink={Object.assign(
            {},
            { route: returnRoute },
            { params: returnParams },
          )}
        />
        {shouldRenderReadme && (
          <Readme
            title={t(conf.sections[2])}
            params={params}
            insideFolder={insideFolder}
            repoManager={repoManager}
            project={project}
            last
          />
        )}
      </>
    );
  }),
);
